import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { IBook } from "../../interfaces";
import { BookCreateForm } from "../../components/books/BookCreateForm";

export const AudioBookCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm<IBook>({});

  return (
    <Create title="Tạo Truyện Audio" saveButtonProps={saveButtonProps}>
      <BookCreateForm type={"audio"} formProps={formProps} />
    </Create>
  );
};
